"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
const LoginBlock_1 = __importDefault(require("../LoginBlock"));
function FakeNeoIDSignIn({ isLower }) {
    return ((0, jsx_runtime_1.jsx)(Overflov, { "data-e2e": 'FakeNeoIDSignIn_Overflov', children: (0, jsx_runtime_1.jsx)(LoginBlockContainer, { "$isMobile": isLower, "data-e2e": 'FakeNeoIDSignIn_LoginBlockContainer', children: (0, jsx_runtime_1.jsx)(LoginBlock_1.default, { "data-e2e": 'FakeNeoIDSignIn_LoginBlock' }) }) }));
}
exports.default = FakeNeoIDSignIn;
const Overflov = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const LoginBlockContainer = styled_components_1.default.div `
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  ${({ $isMobile }) => $isMobile
    ? (0, styled_components_1.css) `
          bottom: 0;
          top: auto;
          transform: translateX(-50%);
        `
    : (0, styled_components_1.css) `
          bottom: auto;
          top: 50%;
          transform: translate(-50%, -50%);
        `}

  & > :first-child {
    ${({ $isMobile, theme }) => $isMobile &&
    (0, styled_components_1.css) `
        border-color: ${theme.white};
        box-sizing: border-box;
        justify-content: center;
        width: 100vw;

        ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
          height: 50vh;
        `)};

        ${ui_1.deviceMainScreenLandscape.tablet((0, styled_components_1.css) `
          height: 80vh;
        `)};
      `}
  }
`;
